<template>
  <div class="student-list">
    <div class="tuolele-main-box">
      <div class="filter-form">
        <div class="filter-top">
          <div class="form-row flex-wrap">
            <div class="form-input">
              <span>选择店铺</span>
              <el-select v-model="filterObj.shop_id" placeholder="请选择">
                <el-option label="全部" value />
                <el-option
                  v-for="item in shopList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </div>
            <div class="form-input">
              <span>家长手机号</span>
              <el-input
                v-model="filterObj.mobile"
                size="large"
                placeholder="请输入查询内容"
              />
            </div>
            <div class="form-input fn-clear">
              <div class="fn-left condition-select">
                <el-select v-model="childCondition" placeholder="请选择">
                  <el-option
                    v-for="item in childOptions"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  />
                </el-select>
              </div>
              <el-input
                v-if="childCondition == 'child_name'"
                v-model="filterObj.child_name"
                size="large"
                placeholder="请输入查询内容"
              />
              <el-input
                v-else
                v-model="filterObj.child_id"
                size="large"
                placeholder="请输入查询内容"
              />
            </div>
            <div>
              <el-button type="primary" @click="searchData">查询</el-button>
              <!-- <el-button
                type="danger"
                @click="clearFilter"
              >重置筛选条件</el-button>
              <el-button
                type="success"
                @click="exportExcel"
              >导出Excel表</el-button> -->
            </div>
          </div>
          <el-row
            v-if="switchObj.LEAD_METHOD == '0'"
            type="flex"
            justify="end"
            class="tuolele-main-search"
          >
            <div v-if="filterObj.shop_id">
              <el-upload
                class="upload-demo"
                action="string"
                :with-credentials="true"
                :show-file-list="false"
                :headers="{ 'Content-Type': 'multipart/form-data' }"
                :http-request="uploadFile"
                accept=".xls"
                name="file"
              >
                <el-button
                  slot="trigger"
                  type="primary"
                >批量导入学员</el-button>
              </el-upload>
            </div>
            <el-button
              v-if="!filterObj.shop_id"
              type="primary"
              @click="beforeUpload"
            >批量导入学员</el-button>
            <el-tooltip placement="left">
              <div slot="content">
                <p class="el-tooltip__popper-text">
                  操作提示：
                  <br>模板表格提供下载，按照模板表格填写后导入学员
                </p>
              </div>
              <i class="el-icon-question" />
            </el-tooltip>
            <el-button
              type="success"
              @click="excelUpload"
            >Excel模板下载</el-button>
          </el-row>
        </div>
        <!-- <div class="filter-body">
          <div class="form-row fn-clear">
            <div class="form-input fn-left">
              <span>剩余课时（常规）</span>
              <el-select v-model="filterObj.formal_type" placeholder="请选择">
                <el-option
                  v-for="item in normalClass"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div
              v-if="filterObj.formal_type == 'between'"
              class="form-input fn-left"
            >
              <el-input
                v-model="formal_start"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天～</label>
              <el-input
                v-model="formal_end"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天</label>
            </div>
            <div
              v-else-if="
                filterObj.formal_type == '>' || filterObj.formal_type == '<'
              "
              class="form-input fn-left"
            >
              <el-input
                v-model="filterObj.formal_value"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天</label>
            </div>
          </div>
          <div class="form-row fn-clear">
            <div class="form-input fn-left">
              <span>剩余课时（假期）</span>
              <el-select v-model="filterObj.holiday_type" placeholder="请选择">
                <el-option
                  v-for="item in holidayClass"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
            </div>
            <div
              v-if="filterObj.holiday_type == 'between'"
              class="form-input fn-left"
            >
              <el-input
                v-model="holiday_start"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天～</label>
              <el-input
                v-model="holiday_end"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天</label>
            </div>
            <div
              v-else-if="
                filterObj.holiday_type == '>' || filterObj.holiday_type == '<'
              "
              class="form-input fn-left"
            >
              <el-input
                v-model="filterObj.holiday_value"
                size="large"
                placeholder="请输入查询内容"
              />
              <label>天</label>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">选择年级</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="gradeList"
                  :select-list="selectGrade"
                  @updateCheck="updateGrade"
                />
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">签约状态</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="orderList"
                  :select-list="selectOrder"
                  @updateCheck="updateOrder"
                />
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">出勤状态</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="attendanceList"
                  :select-list="selectAttendance"
                  @updateCheck="updateAttendance"
                />
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">微信绑定</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="wechatList"
                  :select-list="selectWechat"
                  @updateCheck="updateWechat"
                />
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-input fn-clear">
              <span class="fn-left">学员类型</span>
              <div class="fn-left">
                <Checkbox
                  :list.sync="vipList"
                  :select-list="selectVip"
                  @updateCheck="updateVip"
                />
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div class="table-main">
      <div class="table-header fn-clear">
        <div class="fn-left">
          <Tablist
            :list.sync="tabList"
            :active-id="activeIndex"
            @updateCurrentPage="updateCurrentPage"
          />
        </div>
        <div v-show="activeIndex == 0" class="fn-right table-header-right">
          <!-- <el-pagination
            :current-page.sync="p"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="limit"
            layout="sizes, prev, slot, next"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            @size-change="getManageList"
          >
            <div class="chax">
              {{ p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
            </div>
          </el-pagination> -->
        </div>
      </div>
      <div v-show="activeIndex == 0" class="tuolele-main-box table-body">
        <!-- @sort-change="tableSort" -->

        <el-table
          :data="showList"
          border
          stripe
          :header-cell-style="{
            background: '#4c84ff',
            color: '#fff',
            height: '60px',
            textAlign: 'center'
          }"
        >
          <el-table-column
            prop="child_id"
            label="学员ID"
            align="center"
            sortable="custom"
            fixed
            width="150"
          />
          <el-table-column
            prop="sub_id"
            label="学员长ID"
            align="center"
            sortable="custom"
            fixed
            width="200"
          />
          <el-table-column
            prop="child_name"
            label="学员姓名"
            align="center"
            fixed
            width="150"
          >
            <template slot-scope="scope">
              <img
                v-show="scope.row.vip_status == 1"
                :src="vipIcon"
                class="vip-icon"
                alt
              >
              <span>{{ scope.row.child_name }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="attendance_status"
            label="学员当前状态"
            align="center"
            fixed
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ fnGetReadStatusText(scope.row.read_status) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="attendance_status_name"
            label="出勤状态"
            align="center"
            fixed
            width="150"
          />
          <!-- sortable="custom" -->

          <el-table-column
            prop="formal_day"
            label="剩余课时（常规）"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.formal_day }}天</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="holiday_day"
            label="剩余课时（假期）"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.holiday_day }}天</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="taste_day"
            label="剩余课时（体验）"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.taste_day }}天</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="order_type"
            label="签约类型"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.order_type == 1
                  ? "体验"
                  : scope.row.order_type == 2
                    ? "新签"
                    : "续费"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="shop_name"
            label="所属店铺"
            align="center"
            width="150"
          />
          <el-table-column
            prop="grade_name"
            label="所属年级"
            align="center"
            width="150"
          />
          <el-table-column
            label="周中班主任"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.midweekTeacher.teacher_name
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="weekendTeacher"
            label="周末班主任"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.weekendTeacher.teacher_name
              }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="mobile"
            label="家长手机号"
            align="center"
            width="150"
          /> -->

          <el-table-column
            prop="wechat_binding"
            label="微信绑定状态"
            align="center"
            width="150"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.wechat_binding == 1 ? "已绑定" : "未绑定"
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="150"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="studentDetail(scope.row)"
              >查看</el-button>
              <el-dropdown v-if="switchObj.MASTER_MONEY_CHANGE == 1" :hide-on-click="false" type="primary">
                <span class="el-dropdown-link">
                  余额操作<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="fnAddBill(scope.row)">添加余额</el-dropdown-item>
                  <el-dropdown-item @click.native="fnCustomBillFollow(scope.row)">手动添加余额记录</el-dropdown-item>
                  <el-dropdown-item @click.native="fnBillFollow(scope.row)">余额流水记录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- //更多 -->
              <el-dropdown v-if="switchObj.more == 1" :hide-on-click="false" type="primary">
                <span class="el-dropdown-link">
                  更多<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="fnStopClass(scope.row)">停课</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        v-show="activeIndex == 1"
        class="tuolele-main-box chart-body flex-wrap"
      >
        <Pie
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——就读情况占比统计："
          :query-data.sync="attendData"
        />
        <Pie
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——签约情况占比统计："
          :query-data.sync="signedData"
        />
        <Pie
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——剩余课时（常规）占比统计："
          :query-data.sync="formalData"
        />
        <Pie
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——剩余课时（假期）占比统计："
          :query-data.sync="holidayData"
        />
        <Pie
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——就读年级占比统计："
          :query-data.sync="gradeData"
        />
        <Bar
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="学员——VIP人数情况占比统计："
          :query-data.sync="vipData"
        />
        <Bar
          :query-total="itemTotal"
          desc="满足查询条件总人数："
          title="家长——绑定微信情况占比统计："
          :query-data.sync="weChatData"
        />
      </div>
      <div v-show="activeIndex == 0" class="pagination-footer">
        <div class="block">
          <el-pagination
            layout="prev, pager, next, slot, jumper"
            :current-page.sync="filterObj.p"
            prev-text="上一页"
            next-text="下一页"
            :total="itemTotal"
            :page-size="limit"
            @current-change="getManageList"
          >
            <div class="chax">
              {{ filterObj.p }}/{{ itemTotal > 0 ? Math.ceil(itemTotal / limit) : 1 }}
            </div>
          </el-pagination>
          <div class="insert">
            <el-button type="primary">确定</el-button>
            <span class="pagination-count">
              符合查询结果:
              <i>{{ itemTotal }}条</i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="导入学员失败" :visible.sync="dialogVisible" width="40%">
      <el-table :data="errorList">
        <el-table-column
          property="mobile"
          label="手机号码"
          width="120px"
        />
        <el-table-column
          property="error_msg"
          label="失败信息"
        />
      </el-table>
    </el-dialog>
    <el-dialog
      title="变动（负数为扣除）"
      :visible.sync="dialogVisible1"
      width="80%"
    >
      <div style="font-size: 18px;margin-bottom: 30px;">当前余额: <span style="color:red">{{ masterInfo.money/100 }}</span>元</div>
      <form-box key="addbilldformbox" label-width="150px" :forms="addForms" :post-form="addPostForm" @submit="fnSubmitAdd" />
    </el-dialog>
    <el-dialog
      title="手动添加记录"
      :visible.sync="dialogVisible2"
      top="10%"
      width="80%"
    >
      <wq-table ref="customaddbilltable" :other-query="billFollowListQuery" :url-func="$http.getMasterBillChangeList">
        <el-table-column label="操作时间" prop="create_time" align="center" />
        <el-table-column label="变动金额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.value/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注信息" prop="content" align="center" />
        <el-table-column label="操作人" prop="editor_name" align="center" />

      </wq-table>
    </el-dialog>
    <el-dialog
      title="余额流水记录"
      class="custombillfollow"
      :visible.sync="dialogVisible3"
      width="80%"
    >
      <wq-table ref="custombillfollowhistorylisttable" :limit="10" sub-key="list" show-page :other-query="billFollowListQuery" :url-func="$http.getMasterBillFlow">
        <el-table-column label="操作时间" prop="create_time" align="center" />
        <el-table-column label="变动金额" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.value/100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="备注信息" prop="content" align="center" />
        <el-table-column label="操作人" prop="editor_name" align="center" />

      </wq-table>
    </el-dialog>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
import Bar from '@/components/chart/Bar.vue'
import Pie from '@/components/chart/Pie.vue'
import FormBox from '@/components/FormBox'
// import Checkbox from '@/components/toolbar/Checkbox.vue'
import Tablist from '@/components/toolbar/Tablist.vue'
import WqTable from '@/components/WqTable'
import jquery from 'jquery'

const defaultAddBillPostForm = {
  master_id: '',
  money: '',
  remark: '',
  content: '系统变动'
}

export default {
  name: 'StudentList',
  components: {
    // Checkbox,
    Tablist,
    Pie,
    Bar,
    WqTable,
    FormBox
  },
  data() {
    return {
      switchObj: {},
      addPostForm: Object.assign({}, defaultAddBillPostForm),
      addForms: [{ type: 'input', label: '变动金额', require: true, inputType: 'number', bindValue: 'money' }, { type: 'input', label: '说明', require: true, bindValue: 'remark' }],
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      billFollowListQuery: {
        master_id: '',
        limit: 10
      },
      masterInfo: '',
      errorList: [],
      vipIcon: require('@/assets/img/vip-icon.png'),
      shopList: [],
      tabList: [
        { id: '0', directory_name: '学员信息查询' }
        // { id: '1', directory_name: '数据总览报表' }
      ],
      limit: 20,
      p: 1,
      itemList: [],
      showList: [],
      activeIndex: '0',
      itemTotal: 0,
      childCondition: 'child_name',
      childOptions: [
        { value: 'child_name', text: '学员姓名' },
        { value: 'child_id', text: '学员ID' }
      ],
      normalClass: [
        { value: '', text: '全部' },
        { value: '>', text: '大于' },
        { value: '<', text: '小于' },
        { value: 'between', text: '设置区间' }
      ],
      holidayClass: [
        { value: '', text: '全部' },
        { value: '>', text: '大于' },
        { value: '<', text: '小于' },
        { value: 'between', text: '设置区间' }
      ],
      gradeList: [
        { value: '-2', text: '幼儿园小班' },
        { value: '-1', text: '幼儿园中班' },
        { value: '1', text: '幼儿园大班' },
        { value: '2', text: '一年级' },
        { value: '3', text: '二年级' },
        { value: '4', text: '三年级' },
        { value: '5', text: '四年级' },
        { value: '6', text: '五年级' },
        { value: '7', text: '六年级' },
        { value: '8', text: '初一' },
        { value: '9', text: '初二' },
        { value: '10', text: '初三' }
      ],
      orderList: [
        { value: '1', text: '体验' },
        { value: '2', text: '新签' },
        { value: '4', text: '续费' },
        { value: '6', text: '赠送' }
      ],
      readWithStudentStatus: [
        { value: '0', text: '非在读' },
        { value: '6', text: '在读' },
        { value: '10', text: '待转非在读' }
      ],
      attendanceList: [
        { value: '0', text: '就读中' },
        { value: '1', text: '待开课' },
        { value: '2', text: '请假中' },
        { value: '3', text: '停课中' }
      ],
      wechatList: [
        { value: '0', text: '未绑定' },
        { value: '1', text: '已绑定' }
      ],
      vipList: [
        { value: '1', text: '超级学员' },
        { value: '0', text: '非超级学员' }
      ],
      selectOrder: [],
      selectGrade: [],
      selectAttendance: [],
      selectWechat: [],
      selectVip: [],
      filterObj: {
        shop_id: '',
        formal_type: '',
        holiday_type: '',
        grade_id: '',
        order_type: '',
        attendance_status: '',
        wechat_binding: '',
        vip_status: '',
        order_sort: '',
        order_key: '',
        mobile: '',
        child_name: '',
        child_id: '',
        formal_value: '',
        p: 0
      },
      formal_start: '',
      formal_end: '',
      holiday_start: '',
      holiday_end: '',
      attendData: [
        {
          value: 0,
          key: '0',
          name: '就读中',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '1',
          name: '待开课',
          itemStyle: {
            color: '#6ec7a0'
          }
        },
        {
          value: 0,
          key: '2',
          name: '请假中',
          itemStyle: {
            color: '#fdc373'
          }
        },
        {
          value: 0,
          key: '3',
          name: '停课中',
          itemStyle: {
            color: '#ff6c4c'
          }
        }
      ],
      signedData: [
        {
          value: 0,
          key: '1',
          name: '体验',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '2',
          name: '新签',
          itemStyle: {
            color: '#6ec7a0'
          }
        },
        {
          value: 0,
          key: '4',
          name: '续费',
          itemStyle: {
            color: '#fdc373'
          }
        }
      ],
      formalData: [
        {
          value: 0,
          key: '0,0',
          name: '0天',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '1,15',
          name: '1-15天',
          itemStyle: {
            color: '#6ec7a0'
          }
        },
        {
          value: 0,
          key: '16,30',
          name: '16-30天',
          itemStyle: {
            color: '#fdc373'
          }
        },
        {
          value: 0,
          key: '31,60',
          name: '31-60天',
          itemStyle: {
            color: '#ff6c4c'
          }
        },
        {
          value: 0,
          key: '61,90',
          name: '61-90天',
          itemStyle: {
            color: '#4ac634'
          }
        },
        {
          value: 0,
          key: '91,9999',
          name: '91天及以上',
          itemStyle: {
            color: '#894cff'
          }
        }
      ],
      holidayData: [
        {
          value: 0,
          key: '0,0',
          name: '0天',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '1,10',
          name: '1-10天',
          itemStyle: {
            color: '#6ec7a0'
          }
        },
        {
          value: 0,
          key: '11,20',
          name: '11-20天',
          itemStyle: {
            color: '#fdc373'
          }
        },
        {
          value: 0,
          key: '21,30',
          name: '21-30天',
          itemStyle: {
            color: '#ff6c4c'
          }
        },
        {
          value: 0,
          key: '31,9999',
          name: '31天及以上',
          itemStyle: {
            color: '#4ac634'
          }
        }
      ],
      gradeData: [
        {
          value: 0,
          key: '-2',
          name: '幼儿园小班',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '-1',
          name: '幼儿园中班',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '1',
          name: '幼儿园大班',
          itemStyle: {
            color: '#4c84ff'
          }
        },
        {
          value: 0,
          key: '2',
          name: '一年级',
          itemStyle: {
            color: '#6ec7a0'
          }
        },
        {
          value: 0,
          key: '3',
          name: '二年级',
          itemStyle: {
            color: '#fdc373'
          }
        },
        {
          value: 0,
          key: '4',
          name: '三年级',
          itemStyle: {
            color: '#ff6c4c'
          }
        },
        {
          value: 0,
          key: '5',
          name: '四年级',
          itemStyle: {
            color: '#4ac634'
          }
        },
        {
          value: 0,
          key: '6',
          name: '五年级',
          itemStyle: {
            color: '#894cff'
          }
        }
      ],
      vipData: [
        {
          value: 0,
          key: '1',
          name: '超级学员',
          color: '#4c84ff'
        },
        {
          value: 0,
          key: '0',
          name: '非超级学员',
          color: '#34c6ac'
        }
      ],
      weChatData: [
        {
          value: 0,
          key: '1',
          name: '已绑定',
          color: '#4c84ff'
        },
        {
          value: 0,
          key: '0',
          name: '未绑定',
          color: '#34c6ac'
        }
      ]
    }
  },
  watch: {
    p() {
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    },
    'filterObj.child_name': {
      handler: function() {
        this.filterObj.child_id = ''
      }
    },
    'filterObj.child_id': {
      handler: function() {
        this.filterObj.child_name = ''
      }
    }
  },
  mounted() {
    this.getMyShopList()
    // this.getManageList(this.filterObj)
  },
  methods: {
    fnSubmitAdd(postForm) {
      this.$http.masterMoneySubmit(postForm).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功!')
          this.dialogVisible1 = false
        }
      })
    },
    async fnAddBill(user) {
      this.addPostForm = Object.assign({}, defaultAddBillPostForm, { master_id: user.master_id })
      const res = await this.$http.getMasterMoney(this.addPostForm)
      this.masterInfo = res.data
      this.dialogVisible1 = true
    },
    fnGetReadStatusText(status) {
      const index = Tool.findIndexInArryByKeyVal(this.readWithStudentStatus, 'value', status)
      if (index == -1) {
        return '未知状态'
      }
      return this.readWithStudentStatus[index].text
    },
    fnStopClass(user) {
      this.$prompt(`确认为<${user.child_name}>停课吗？请输入停课原因`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', inputPattern: /[\S\s]+/, inputErrorMessage: '停课原因不能为空' }).then(value => {
        this.$http.stopClass({ childId: user.child_id, remark: value.value }).then(res => {
          if (res.code == 200) {
            this.$message({ type: 'success', message: '操作成功!' })
          }
        })
      })
      // this.$confirm(`确认为<${user.child_name}>停课吗？`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
      //   this.$http.stopClass({ childId: user.child_id }).then(res => {
      //     if (res.code == 200) {
      //       this.$message({ type: 'success', message: '操作成功!' })
      //     }
      //   })
      // })
    },
    fnCustomBillFollow(user) {
      this.billFollowListQuery.master_id = user.master_id
      this.dialogVisible2 = true
    },
    fnBillFollow(user) {
      this.billFollowListQuery.master_id = user.master_id
      this.dialogVisible3 = true
    },
    excelUpload() {
      window.location.href =
        'http://late-care.tuolele.cn/%E6%89%B9%E9%87%8F%E5%AD%A6%E5%91%98%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF.xls'
    },
    beforeUpload() {
      this.$message({
        type: 'info',
        message: '请选择店铺'
      })
    },
    uploadFile(params) {
      const file = params.file
      const self = this
      const formData = new FormData()
      formData.append('file', file)
      formData.append('shop_id', this.filterObj.shop_id)
      jquery.ajax({
        // url: "http://172.16.10.234:8889/cms.php/Excelupload/appendChildren",
        url: 'http://third.tuolele.cn/cms.php/Excelupload/appendChildren',
        type: 'post',
        data: formData,
        contentType: false,
        processData: false,
        xhrFields: {
          withCredentials: true
        },
        crossDomain: true,
        success: function(res) {
          if (res.code == 200) {
            self.$message({
              type: 'success',
              message: '导入成功！'
            })
          } else if (res.code == 540 && res.data) {
            self.errorList = res.data
            self.dialogVisible = true
          } else if (res.code == 550) {
            self.$message({
              type: 'info',
              message: res.desc
            })
          }
        }
      })
    },
    async getMyShopList() {
      const ret = await this.$http.getMyShopList()
      if (ret.code == 200) {
        this.shopList = ret.data
      }
    },
    async getManageList(filterObj) {
      // if (filterObj.vip_status == '') {
      //   filterObj.vip_status = '0,1'
      // }
      // if (filterObj.wechat_binding == '') {
      //   filterObj.wechat_binding = '0,1'
      // }
      // if (filterObj.attendance_status == '') {
      //   filterObj.attendance_status = '0,1,2,3'
      // }
      const ret = await this.$http.getManageList(this.filterObj)
      if (ret.code == 200) {
        this.switchObj = ret.data.switch
        this.showList = ret.data.list
        // this.showList = this.itemList.slice(
        //   (this.p - 1) * this.limit,
        //   (this.p - 1) * this.limit + this.limit
        // )
        this.itemTotal = parseInt(ret.data.count || 0)
        // this.attendData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return ele.attendance_status == e.key
        //   })
        //   e.value = list.length
        // })
        // this.signedData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return ele.order_type == e.key
        //   })
        //   e.value = list.length
        // })
        // this.formalData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return (
        //       ele.formal_day - 0 >= e.key.split(',')[0] - 0 &&
        //       ele.formal_day - 0 <= e.key.split(',')[1] - 0
        //     )
        //   })
        //   e.value = list.length
        // })
        // this.holidayData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return (
        //       ele.holiday_day - 0 >= e.key.split(',')[0] - 0 &&
        //       ele.holiday_day - 0 <= e.key.split(',')[1] - 0
        //     )
        //   })
        //   e.value = list.length
        // })
        // this.gradeData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return ele.grade_name == e.name
        //   })
        //   e.value = list.length
        // })
        // this.vipData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return ele.vip_status == e.key
        //   })
        //   e.value = list.length
        // })
        // this.weChatData.forEach(e => {
        //   const list = this.itemList.filter(ele => {
        //     return ele.wechat_binding == e.key
        //   })
        //   e.value = list.length
        // })
      } else {
        this.$message({
          type: 'error',
          message: ret.desc
        })
      }
    },
    exportExcel() {
      const tHeader = [
        '学员ID',
        '学员姓名',
        '学员当前状态',
        '剩余课时（常规）',
        '剩余课时（假期）',
        '剩余课时（体验）',
        '签约类型',
        '所属店铺',
        '所属年级',
        '所属班主任',
        '家长手机号',
        '家长姓名',
        '微信绑定状态'
      ]
      const filterVal = [
        'child_id',
        'child_name',
        'attendance_status',
        'formal_day',
        'holiday_day',
        'taste_day',
        'order_type',
        'shop_name',
        'grade_name',
        'teacher_name',
        'mobile',
        'member_name',
        'wechat_binding'
      ]
      let list = JSON.stringify(this.itemList)
      list = JSON.parse(list)
      list.forEach(e => {
        e.order_type =
          e.order_type == '1' ? '体验' : e.order_type == '2' ? '新签' : '续费'
        e.wechat_binding = e.wechat_binding == '1' ? '已绑定' : '未绑定'
        e.attendance_status =
          e.attendance_status == '0'
            ? '就读中'
            : e.attendance_status == '1'
              ? '待开课'
              : e.attendance_status == '2'
                ? '请假中'
                : '停课中'
      })
      Tool.exportExcel(tHeader, filterVal, list, '学员信息')
    },
    tableSort(val) {
      this.filterObj.order_key = val.prop
      this.filterObj.order_sort =
        val.order == 'ascending' ? '4' : val.order == 'descending' ? '3' : ''
      this.getManageList(this.filterObj)
    },
    searchData() {
      if (this.filterObj.formal_type == 'between') {
        if (this.formal_start == '' || this.formal_end == '') {
          this.$message({
            type: 'warning',
            message: '请输入完整区间'
          })
          return false
        }
        this.filterObj.formal_value = this.formal_start + ',' + this.formal_end
      }
      if (this.filterObj.holiday_type == 'between') {
        if (this.holiday_start == '' || this.holiday_end == '') {
          this.$message({
            type: 'warning',
            message: '请输入完整区间'
          })
          return false
        }
        this.filterObj.holiday_value =
          this.holiday_start + ',' + this.holiday_end
      }
      this.getManageList(this.filterObj)
    },
    clearFilter() {
      for (const key in this.filterObj) {
        if (this.filterObj.hasOwnProperty(key)) {
          this.filterObj[key] = ''
        }
      }
      this.selectOrder = []
      this.selectGrade = []
      this.selectAttendance = []
      this.selectWechat = []
      this.selectVip = []
    },
    studentDetail(item) {
      const { href } = this.$router.resolve({
        name: '学员详情',
        query: { child_id: item.child_id }
      })
      // this.$router.push({
      //   path: "studentDetails",
      //   query: { child_id: item.child_id }
      // });
      window.open(href, '_blank')
    },
    updateCurrentPage(val) {
      this.activeIndex = val
    },
    updateGrade(val) {
      this.selectGrade = val
      this.filterObj.grade_id = val.join(',')
    },
    updateOrder(val) {
      this.selectOrder = val
      this.filterObj.order_type = val.join(',')
    },
    updateAttendance(val) {
      this.selectAttendance = val
      this.filterObj.attendance_status = val.join(',')
    },
    updateWechat(val) {
      this.selectWechat = val
      this.filterObj.wechat_binding = val.join(',')
    },
    updateVip(val) {
      this.selectVip = val
      this.filterObj.vip_status = val.join(',')
    },
    handleSizeChange(val) {
      this.limit = val
      this.showList = this.itemList.slice(
        (this.p - 1) * this.limit,
        (this.p - 1) * this.limit + this.limit
      )
    }
  }
}
</script>

<style lang="scss" scoped>

.student-list {
  // ::v-deep .el-dialog {
  //   margin-top: 10%!important;
  // }
  .el-dropdown-link{
    color: #4c84ff;
    cursor: pointer;
    font-weight: bold;
    margin-left: 10px
  }
  .custombillfollow {
    ::v-deep .el-pagination .el-pager {
      li {
        border: solid 1px #4c84ff!important;
        color:#4c84ff!important;
        opacity:1!important
      }
      li.active {
        color:white!important;
      }
    }
  }
  .tuolele-main-box {

    ::v-deep .filter-form {
      .filter-top {
        padding-bottom: 40px;
        border-bottom: 1px solid #f5f5f5;
      }
      .form-row {
        flex-wrap: wrap;
        justify-content: space-between;
        .form-input {
          .condition-select {
            .el-input {
              width: 120px !important;
            }
            .el-select {
              width: 120px !important;
              margin-right: 20px;
            }
          }
        }
      }
      .filter-body {
        padding-top: 20px;
      }
    }
  }
  .table-main {
    .table-header {
      .table-header-right {
        padding-top: 10px;
      }
    }
  }
  .chart-body {
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.filter-form {
  .el-button {
    padding: 0 30px;
    height: 40px;
  }
}

.vip-icon {
  width: 16px;
  margin-right: 6px;
  vertical-align: text-bottom;
}
</style>
